import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from '../../utils/axios';
import {
  cancelSubscriptionFailure,
  cancelSubscriptionRequest,
  cancelSubscriptionSuccess,
  createSubscriptionFailure,
  createSubscriptionRequest,
  createSubscriptionSuccess,
  editSubscriptionFailure,
  editSubscriptionRequest,
  editSubscriptionSuccess,
  fetchSubscriptionById,
  fetchSubscriptionByIdFailure,
  fetchSubscriptionByIdSuccess,
  fetchSubscriptionsFailure,
  fetchSubscriptionsRequest,
  fetchSubscriptionsSuccess,
} from './subscriptionSlice';

function* fetchSubscriptionsSaga(action) {
  try {
    const { email, page, limit } = action.payload;
    const params = {
      email,
      page,
      limit,
    };
    const response = yield call(axiosInstance.get, '/subscriptions', { params });
    yield put(fetchSubscriptionsSuccess(response.data));
  } catch (error) {
    yield put(fetchSubscriptionsFailure(error.message));
  }
}

function* fetchSubscriptionByIdSaga(action) {
  try {
    const response = yield call(axiosInstance.get, `/subscriptions/${action.payload}`);
    yield put(fetchSubscriptionByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchSubscriptionByIdFailure(error.message));
  }
}

function* editSubscriptionRequestSaga(action) {
  try {
    const { _id, __v, createdAt, updatedAt, ...sanitizedPayload } = action.payload;
    const response = yield call(axiosInstance.put, `/subscriptions/${_id}`, sanitizedPayload);
    yield put(editSubscriptionSuccess(response.data));
  } catch (error) {
    yield put(editSubscriptionFailure(error.response.data.error));
  }
}

function* createSubscriptionSaga(action) {
  try {
    const response = yield call(axiosInstance.post, '/subscriptions', action.payload);
    yield put(createSubscriptionSuccess(response.data));
  } catch (error) {
    yield put(createSubscriptionFailure(error.response.data.errors));
  }
}

function* cancelSubscriptionSaga(action) {
  try {
    const { id } = action.payload;
    const response = yield call(axiosInstance.put, `/subscriptions/${id}/cancel`, action.payload);
    yield put(cancelSubscriptionSuccess(response.data));
  } catch (error) {
    yield put(cancelSubscriptionFailure(error.response.data.errors));
  }
}

function* subscriptionSaga() {
  yield takeLatest(fetchSubscriptionsRequest.type, fetchSubscriptionsSaga);
  yield takeEvery(fetchSubscriptionById.type, fetchSubscriptionByIdSaga);
  yield takeLatest(createSubscriptionRequest.type, createSubscriptionSaga);
  yield takeLatest(editSubscriptionRequest.type, editSubscriptionRequestSaga);
  yield takeLatest(cancelSubscriptionRequest.type, cancelSubscriptionSaga);
}

export default subscriptionSaga;
